"use client";
import { useSyncExternalStore } from "react";
import Dialog from "./Dialog";
import { STORE_KEYS } from "app/constants";
import Image from "next/image";
import { SignupLink } from "./SignupLink";
import { SigninLink } from "./SigninLink";
import { useStaticStore } from "app/hooks";
import { sessionStore } from "@lib/sessionStore";

export function PopupRequireSignin() {
  const { sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.requireSigninPopup);

  if (sessionStatus === "unauthenticated") {
    return (
      <Dialog storeKey={STORE_KEYS.requireSigninPopup} className="mode-req-signin">
        <p className="dialog-h">
          このエピソードを読むには
          <br />
          アカウント登録が必要です
        </p>
        <div className="dialog-main">
          <figure className="dialog-main-fig">
            <Image
              className="dialog-main-img"
              src="/images/popup/register_img_popup.svg"
              alt=""
              width="327"
              height="213"
            />
          </figure>
          <div className="dialog-btns">
            <SignupLink
              className="dialog-btn mode-primary"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              無料登録する
            </SignupLink>
            <span className="dialog-main-devider">
              <span className="dialog-main-devider-text">登録済みなら</span>
            </span>
            <SigninLink
              className="dialog-btn mode-secondary"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              ログイン
            </SigninLink>
          </div>
        </div>
      </Dialog>
    );
  }
}
